import React from 'react';
import { ReactComponent as RobotBigIcon } from '../../svg/robot_big.svg';
import { Circle, Container } from './styles';

interface RobotWithPulseProps {
  size?: number;
}

const RobotWithPulse: React.FC<RobotWithPulseProps> = ({ size = 200 }) => {
  const circleSize = size / 2;
  const robotSize = size / 3.5;

  return (
    <Container>
      <Circle style={{ animationDelay: '0s' }} circleSize={circleSize} />
      <Circle style={{ animationDelay: '-1s' }} circleSize={circleSize} />
      <Circle style={{ animationDelay: '-2s' }} circleSize={circleSize} />

      <div
        style={{
          position: 'relative',
          zIndex: 2,
        }}
      >
        <RobotBigIcon
          style={{
            width: robotSize,
            height: robotSize,
          }}
        />
      </div>
    </Container>
  );
};

export default RobotWithPulse;
